import { render, staticRenderFns } from "./Notaries.vue?vue&type=template&id=dd27cbc4&lang=html&"
import script from "./Notaries.vue?vue&type=script&lang=js&"
export * from "./Notaries.vue?vue&type=script&lang=js&"
import style0 from "./Notaries.vue?vue&type=style&index=0&id=dd27cbc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports